import type { SVGProps } from 'react';

const SvgHousePlusOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.94 2.45a2.66 2.66 0 0 1 1.685.553.853.853 0 1 1-1.041 1.353.96.96 0 0 0-1.2.025L5.046 9.813a.96.96 0 0 0-.34.731v8.147a.957.957 0 0 0 .958.957H8.43V13.26A1.76 1.76 0 0 1 10.19 11.5h3.62a1.76 1.76 0 0 1 1.759 1.759v6.388h2.767a.957.957 0 0 0 .957-.957v-6.657a.853.853 0 1 1 1.707 0v6.657a2.664 2.664 0 0 1-2.664 2.664H5.664A2.664 2.664 0 0 1 3 18.69v-8.147a2.67 2.67 0 0 1 .942-2.033L10.28 3.08a2.66 2.66 0 0 1 1.658-.628m-1.802 17.198h3.724V13.26a.05.05 0 0 0-.052-.052h-3.62a.05.05 0 0 0-.052.052zM17.43 3.355c.471 0 .854.382.854.853V6.07h1.862a.853.853 0 0 1 0 1.707h-1.862v1.862a.853.853 0 0 1-1.707 0V7.777h-1.862a.853.853 0 0 1 0-1.707h1.862V4.208c0-.471.382-.853.853-.853"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgHousePlusOutlined;
